// extracted by mini-css-extract-plugin
export default {"maintenanceText":"unsupported-currency-notice_maintenanceText__yCz1n"};